/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    SET_FETCH_REC_AREA_STATUS,
    FETCH_REC_AREA_SUCCESS,
    FETCH_REC_AREA_ERROR,
} from '../actions/recAreaActions';

export const initialState = {
    isLoading: true,
    loadingStatus: 'idle',
};

export const recAreaReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_REC_AREA_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_REC_AREA_SUCCESS: {
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
            };
        }

        case FETCH_REC_AREA_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        default:
            return state;
    }
};
